export default __webpack_public_path__ + "static/media/Astro_Saturn_White.e833b1f4.png";